import api from "config/axios.config";
import { ISubCategory } from "../types/sub-category.type";

export const getAllSubCategory = (): Promise<ISubCategory[]> =>
  api.get(`clients/${process.env.REACT_APP_CLIENT_ID}/sub-category`);
